import { useState } from "react";
import { Play } from "lucide-react";

export default function VideoCard({ video, featured = false }) {
  const [isPlaying, setIsPlaying] = useState(false);
  
  const thumbnailUrl = `https://img.youtube.com/vi/${video.youtube_id}/maxresdefault.jpg`;
  const embedUrl = `https://www.youtube.com/embed/${video.youtube_id}?autoplay=1&rel=0`;

  if (isPlaying) {
    return (
      <div className={`relative overflow-hidden rounded-xl bg-slate-900 ${featured ? 'aspect-video' : 'aspect-video'}`}>
        <iframe
          src={embedUrl}
          title={video.title}
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div 
      className={`relative overflow-hidden rounded-xl bg-slate-900 cursor-pointer group ${featured ? 'aspect-video' : 'aspect-video'}`}
      onClick={() => setIsPlaying(true)}
      data-testid={`video-card-${video.id}`}
    >
      <img
        src={thumbnailUrl}
        alt={video.title}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
        onError={(e) => {
          e.target.src = `https://img.youtube.com/vi/${video.youtube_id}/hqdefault.jpg`;
        }}
      />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      
      {/* Play button */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
          <Play className="w-8 h-8 md:w-10 md:h-10 text-slate-900 ml-1" fill="currentColor" />
        </div>
      </div>
      
      {/* Title */}
      <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
        <h3 className="text-white font-semibold text-sm md:text-lg line-clamp-2">{video.title}</h3>
        {video.description && (
          <p className="text-white/70 text-xs md:text-sm mt-1 line-clamp-2 hidden md:block">{video.description}</p>
        )}
      </div>
      
      {/* Featured badge */}
      {video.is_featured && (
        <div className="absolute top-4 left-4">
          <span className="badge-featured">Featured</span>
        </div>
      )}
    </div>
  );
}
